<template>
    <modal  v-model="fade"  class-name="vertical-center-modal" width="400" :mask-closable="maskClosable" @on-visible-change="changeModal">
        <div slot="header" >
            <div class="register-header">{{title}}</div>
        </div>
        <div slot="close">
            <div class="close" @click="hide">x</div>
        </div>
        <Form class="form-group" ref="registerData" :model="registerData"  :rules="ruleValidate">
            <FormItem  prop="name">
                <Input type="text"  size="large" v-model.trim="registerData.name" :placeholder="placeholderInfo.name">
                    <Icon type="ios-contact" color="#2d8cf0" slot="prefix" />
                </Input>
            </FormItem>
            <FormItem  prop="phone">
                <Input type="tel"  size="large" v-model.trim="registerData.phone" :placeholder="placeholderInfo.phone">
                    <Icon type="ios-phone-portrait" color="#2d8cf0" slot="prefix" />
                </Input>
            </FormItem>
            <FormItem  prop="captchaCode" v-if="needCaptchaCode">
                <Input type="text" ref="captchaCodeInput" style="width: 160px"  size="large" v-model.trim="captchaCode" :placeholder="placeholderInfo.captchaCode">
                </Input>
                <img style="vertical-align: bottom;margin-left: 30px" :src="codeImgUrl" class="img" @click="updateCodeImgUrl">
            </FormItem>
            <FormItem  prop="verifyCode">
                <Input type="number" style="width: 63%"  size="large" v-model.trim="registerData.verifyCode" :placeholder="placeholderInfo.verifyCode">
                    <Icon type="ios-search" color="#2d8cf0" slot="prefix" />
                </Input>
                <Button @click="getCode" class="btn-get-code" size="large" :disabled="getCodeIng" type="primary" ghost>{{getCodeMsg}}</Button>
            </FormItem>
            <!--<FormItem  prop="email">-->
                <!--<Input type="email"  size="large" v-model="registerData.email" :placeholder="placeholderInfo.email">-->
                    <!--<Icon type="ios-mail-outline" color="#2d8cf0" slot="prefix" />-->
                <!--</Input>-->
            <!--</FormItem>-->
            <FormItem  prop="password">
                <Input type="password"  size="large" v-model.trim="registerData.password" :placeholder="placeholderInfo.password">
                    <Icon type="ios-lock-outline" color="#2d8cf0" slot="prefix" />
                </Input>
            </FormItem>
            <FormItem class="form-footer">
                <Button type="primary" long size="large" :loading="isLoading" @click="handleSubmit('registerData')">
                    <span v-if="!isLoading" style="font-size: 16px">注册</span>
                    <span v-else>加载中</span>
                </Button>
            </FormItem>
            <div class="to-register">已有账号，<a href="#" @click="toLogin">去登录</a></div>
        </Form>
        <div slot="footer"></div>
    </modal>
</template>

<script>
    import api from '../../api/api'
    import {mapState, mapActions} from 'vuex'
    import util from '../../utils/util'
    export default {
        props:{
            title:{
                type:String,
                default:'注册'
            },
            placeholderInfo:{
                type:Object,
                default(){
                    return {
                        name: '请输入用户昵称',
                        password: '请输入密码',
                        verifyCode: '请输入短信验证码',
                        // email: '请输入邮箱',
                        phone:'请输入手机号',
                        captchaCode:'请输如图片验证码'
                    };
                }
            },
            placeholderPsw:{
                type:String,
                default:'请输入密码'
            },
            maskClosable:{
                type:Boolean,
                default:true
            }
        },
        data:()=>{
            return{
                fade:false,
                isLoading:false,
                getCodeIng:false,
                getCodeMsg:'获取验证码',
                codeImgUrl:'',
                captchaCode:'',
                timerHandler:null,
                needCaptchaCode:false,
                registerData:{
                    name:'',
                    password:'',
                    phone:'',
                    email:'',
                    verifyCode:''
                },
                ruleValidate: {
                    name: [
                        { required: true, message: '账号不能为空', trigger: 'blur' },
                        { min: 3, max: 16, message: '账号长度3-16个字符', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '密码不能为空', trigger: 'blur' },
                        { type: 'string', min: 6, max: 16, message: '密码长度6-16个字符', trigger: 'blur' }
                    ],
                    phone: [
                        { required: true, message: '手机号码不能为空', trigger: 'blur' },
                        { type: 'string', min: 11, max: 11, message: '手机号码长度错误', trigger: 'blur' }
                    ],
                    // email: [
                    //     { required: true, message: '邮箱不能为空', trigger: 'blur' },
                    //     { type: 'string', message: '密码长度6-16个字符', trigger: 'blur' }
                    // ],
                    verifyCode: [
                        { required: true, message: '验证码不能为空', trigger: 'blur' },
                        { type: 'string', trigger: 'blur' }
                    ]
                }
            }
        },
        computed: {
        },
        methods:{
            ...mapActions([
                'loginSuccess'
            ]),
            updateCodeImgUrl(){
                this.codeImgUrl = ''
                this.codeImgUrl = util.getHost()+"/captcha?clientIdentifierCode="+util.getLocalStroageUUID() + "&t=" + new Date().getTime()
            },
            countDown : function (btnMsg,seconder) {
                if(!btnMsg){
                    return
                }
                if(this.getCodeIng)return
                var that = this;
                var seconder = seconder||30;
                var seconderText = ''
                this[btnMsg]='剩余('+seconder+')秒'
                if(this.timerHandler){
                    clearInterval(this.timerHandler);
                }
                this.getCodeIng = true;
                this.timerHandler = setInterval(function () {
                    if(seconder>0){
                        seconder--;
                        seconderText = seconder
                        if(seconderText<10){
                            seconderText = '0'+seconderText
                        }
                        that[btnMsg]='剩余('+seconderText+')秒'
                    }else{
                        clearInterval(this.timerHandler);
                        that.getCodeIng = false;
                        that[btnMsg] ="获取验证码";
                    }
                },1000)
            },
            initCountDown(btnMsg){
                this[btnMsg] ="获取验证码";
                this.getCodeIng = false;
                clearInterval(this.timerHandler);
            },
            _initModalData(){
                this.registerData={
                    name:'',
                    password:'',
                    phone:'',
                    verifyCode:''
                };
                this.needCaptchaCode = false;
                this.captchaCode = '';
                this.codeImgUrl = ''

            },
            hide() {
                this._initModalData()
                this.fade = false
            },
            open() {
                this.fade = true;
            },
            changeModal(data){
                if(!data){
                    this.hide()
                }
            },
            toLogin(){
                this._initModalData()
                this.$emit('toLogin')
            },
            handleSubmit (name) {
                var self = this;
                this.isLoading = true;
                this.$refs[name].validate((valid) => {
                    var data = this.$refs[name].model
                    console.log('注册提交信息：--',data)
                    if(valid){
                        api.register(data).then(res=>{
                            self.isLoading = false;
                            self.$Message.success('注册成功')
                            console.log('注册信息：--',res)
                            self.loginSuccess(res)
                            self.hide()
                        }).catch(error =>{
                            self.isLoading = false;
                            self.$Message.error(error.info)
                        })
                    }else{
                        self.isLoading = false;
                        self.$Message.error('表单验证失败!')
                    }
                })
            },
            initImgCodeInfo(){
                this.needCaptchaCode = true
                this.updateCodeImgUrl()
            },
            getCode(){
                var self = this;
                var phone = this.registerData.phone;
                if(!phone){
                    this.$Message.error('请输入手机号码!')
                    return
                }
                if(this.getCodeIng)return
                console.log('getCodeIng:',this.getCodeIng)
                this.countDown('getCodeMsg',60)
                api.getRegisterCode(phone,this.captchaCode).then(res =>{
                    self.registerData.verifyCode = res.verifyCode || '';
                }).catch(error =>{
                    self.initCountDown('getCodeMsg')
                    if(error.code==4){
                        self.initImgCodeInfo()
                    }
                    self.$Message.error(error.info)
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .register-header{
        font-size: 18px;
        text-align: left;
        letter-spacing: 3px;
        color: #333;
        font-weight: 600;
    }
    .close{
        width: 18px;
        height: 18px;
        color: #fff;
        font-size: 14px;
        margin-top: 5px;
        text-align: center;
        line-height: 18px;
        background: #ccc;
        border-radius: 15px
    }
    .form-group{
        width: 90%;
        margin: 0 auto;
        .form-item{
            padding-top: 20px;
        }
    }
    .btn-get-code{
        margin-left: 20px;
    }
    .ivu-input-prefix i{
        color: #2d8cf0;
    }
    .forget-pwd{
        text-align: right;
        padding-bottom: 10px;
        font-size: 14px;
    }
    .to-register{
        text-align: left;
        /*padding: 10px 0;*/
    }
</style>